<template>
	<div class="col-12 xl:col-7">
		<div class="card">
			<h2>Change Password</h2>
			<div class="fluid grid">

				<div class="field col-12">
					<div class="float-right label"># {{ loginId }}</div>
					<label>Login Email</label>
					<form autocomplete="off">
						<InputText v-model="userName" :disabled="true" />
					</form>
				</div>

				<div class="field col-12">
					<label>Login Password</label> <br />
					<form autocomplete="off">
						<InputText v-model.trim="password" @change="passwordChanged = true" placeholder="Type a new password" />
					</form>
				</div>

				<div class="field col-12">
					<label>Re-enter Password</label> <br />
					<form autocomplete="off">
						<InputText v-model.trim="passwordReEntered" @change="passworReEnteredChanged = true" placeholder="Re-enter the password" />
					</form>
				</div>
			</div>
		</div>
	</div>

	<!-- Floating Save/Cancel buttons -->
	<Button class="sticky-button cancel" icon="pi pi-times" :label="hasChanges ? 'Cancel' : 'Close'" @click="cancel" v-if="!loading" />
	<Button class="sticky-button" icon="pi pi-check" label="Save" @click="changePassword" v-if="!loading" :disabled="!hasChanges" />
	
</template>

<script lang="ts">
	import { Vue } from 'vue-class-component';
	import { CompassApi } from '@/api-client/CompassApiProxy';
	import { ChangePasswordRequest } from '../api-client/api-client';
	import { allowLeaveOnlyWithConfirmationOrNoChanges } from '@/components/LeaveWithoutSavingPrompt';
	import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
	import Toast from '@/utils/Toast';

	Vue.registerHooks([
		'beforeRouteLeave',
	]);

	export default class UserDetails extends Vue {

		loginId!: number;  // Grabbed from the state
		userName!: string; // Grabbed from the state (email)
		password: string | null = null;
		passwordReEntered: string | null = null;
		passwordChanged = false;
		passworReEnteredChanged = false;
		loading = true;

		created() {
			this.password = null;
			this.loginId = this.$store.state.loginID;
			this.userName = this.$store.state.email;

			if (this.loginId <= 0) {
				// Should not get here but in case it does, go back
				this.$router.go(-1);
			}

			this.loading = false;
		}

		// Actions
		changePassword() {

			// Remove any toast messages if they exist
			Toast.RemoveAllGroups();

			if (this.password && this.passwordReEntered) {

				const requestModel: ChangePasswordRequest = new ChangePasswordRequest();
				requestModel.loginId = this.loginId;
				requestModel.password = this.password;
				requestModel.passwordReEntered = this.passwordReEntered;

				// Change the password
				const apiClient = CompassApi.userApi(this.$store);
				apiClient.changePassword(requestModel)
					.then(() => {
						this.loading = false;

						// reset passwordChanged flag
						this.passwordChanged = false;

						// reset input text passwords
						this.password = null;
						this.passwordReEntered = null;

						Toast.Success('Change Password', 'Password succesfully changed for user `' + this.userName + '`');
					})
					.catch(error => {
						this.loading = false;

						if (error.status == 400) {
							Toast.Error('Error changing password for user ' + this.userName, error.response);
						}
						else {
							Toast.ApiError('Error changing password for user `' + this.userName + '`', error);
						}
					});
			}
		}

		cancel() {
			this.$router.go(-1);
		}

		  beforeRouteLeave(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
			allowLeaveOnlyWithConfirmationOrNoChanges(this, this.hasChanges, next);
		}

		get hasChanges(): boolean {
			return this.passwordChanged && this.passworReEnteredChanged;
		}
	}
</script>

<style scoped lang="scss">
</style>